import { seo } from "../../../common/helpers/seo";

import lazyComponent from "./lazy";

export default {
    component: lazyComponent,
    renderSeo: (store, allMessage, lang) => {
        return seo({ title: allMessage["etp.verifyEmail.title"], allMessage, lang });
    },
};
